import $ from 'cash-dom'
import { Api } from './api'
import { priceToCurrency } from './utils'

const $els = {
  body: $('body'),
  subtotal: $('.cart-subtotal'),
  checkout: $('.cart-checkout'),
  footer: $('.cart-footer'),
  items: $('.cart-items'),
  empty: $('.cart-empty'),
  count: $('.cart-count'),
  fill: $('.cart-fill'),
  toggle: $('.cart-toggle'),
  cartContent: $('.cart-content'),
  cartContentContainer: $('.cart-content-container'),
  prevFocusedElement: null,
}

const renderImage = (image, title) => {
  return `
    <div class="cart-item-image border border-gray-300 bg-gray-100 w-20 h-28 lg:w-32 lg:h-40 relative mb-3 lg:mb-0">
      <img class="absolute w-full h-full inset-0 object-cover object-center" src="${image}" alt="${title}" loading="lazy" />
    </div>
  `
}
const renderProductTitle = (label, title, url) => {
  return `
    <div class="cart-item-title mb-2 md:mb-3 lg:mb-0">
      <p>
        <a href="${url}">
          ${title}
        </a>
      </p>
    </div>
  `
}
const renderVariants = (optionsWithValues) => {
  return `
    <div class="cart-item-variants">
      ${optionsWithValues
        .map((o) =>
          o.value !== 'Default Title'
            ? `
        <div class="mb-2 md:mb-3 lg:mb-6">
          <p>
            ${o.value}
          </p>
        </div>
      `
            : ``
        )
        .join('')}
    </div>
  `
}
const renderPrice = (price, label) => {
  return `
    <div class="cart-item-price lg:flex lg:justify-end lg:pt-2 lg:pr-4">
      <p>
        ${price}
      </p>
    </div>
  `
}
const renderQuantity = (quantity, id) => {
  return `
    <div class="cart-item-quantity w-20">
      <div class="w-full inline-block border border-gray-300 h-10 relative">
        <div class="w-full flex justify-between items-center px-3 h-full">
          <span class="caption text-xs">${quantity}</span>
          <div class="transform-gpu rotate-90">
            <svg width="8" viewBox="0 0 12 22" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" stroke-linejoin="round">
                <path d="M1.7 1.6L10.6 10.6C10.7 10.7 10.8 10.8 10.8 11 10.8 11.2 10.7 11.3 10.6 11.4L1.7 20.4" stroke-width="1.6" stroke="currentColor"></path>
              </g>
            </svg>
          </div>
        </div>
        <select
          name="quantity"
          data-id="${id}"
          class="opacity-0 absolute top-0 left-0 w-full h-full"
          tabindex="0"
          aria-label="Select quantity"
        >
          <option value="1" ${quantity === 1 && 'selected'}>1</option>
          <option value="2" ${quantity === 2 && 'selected'}>2</option>
          <option value="3" ${quantity === 3 && 'selected'}>3</option>
          <option value="4" ${quantity === 4 && 'selected'}>4</option>
          <option value="5" ${quantity === 5 && 'selected'}>5</option>
        </select>
      </div>
    </div>
  `
}
const renderRemove = (id, label, title) => {
  return `
    <div class="grid justify-end lg:justify-start">
      <button data-id="${id}" class="cart-item-remove group grid grid-flow-col gap-3 items-center" aria-label="Remove ${title}" tabindex="0">
        <span class="caption text-gray-500 order-1 lg:order-2">${label}</span>
        <span class="grid w-10 h-10 border transition-border duration-200 border-gray-300 rounded-full items-center justify-center group-hover:border-black order-2 lg:order-1">
          <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#000" fill="none" fill-rule="evenodd"><path d="m.5.5 9 9M9.5.5l-9 9"/></g>
          </svg>
        </span>
      </button>
    </div>
  `
}

const renderCartItem = (item, isLast) => {
  const {
    url,
    image,
    quantity,
    handle,
    price,
    variant_id: variantId,
    product_title: productTitle,
    options_with_values: optionsWithValues,
  } = item
  const formattedPrice = priceToCurrency(price)
  const nonLastClasses = !isLast ? `border-b border-gray-300` : ``
  const productLabel = $els.items.data('product-label')
  const priceLabel = $els.items.data('price-label')
  const removeLabel = $els.items.data('remove-label')
  return `
      <div class="cart-item grid items-start py-4 ${nonLastClasses}">
        <div class="cart-item-id visually-hidden" data-variant-id="${variantId}"></div>
        ${renderImage(image, productTitle)}
        ${renderProductTitle(productLabel, productTitle, url)}
        ${renderVariants(optionsWithValues)}
        ${renderQuantity(quantity, variantId)}
        ${renderRemove(variantId, removeLabel, productTitle)}
        ${renderPrice(formattedPrice, priceLabel)}
      </div>
    `
}

export const closeCart = () => {
  const main = document.querySelector('main')
  $els.body.removeClass('overflow-hidden cart--open')
  document.body.style.marginRight = `${0}px`
  $('.site-header__top-tier').css(`width`, `${document.body.clientWidth}px`)
  $('.site-header__bottom-tier').css(`width`, `${document.body.clientWidth}px`)
  $('.site-header').removeClass('toggle--open cart--open')

  if ($('.banner__content.active').data('header-style') === 'solid_black') {
    $('.site-header').addClass('site-header--dark')
  } else if (
    $('.banner__content.active').data('header-style') === 'solid_white'
  ) {
    $('.site-header').removeClass('site-header--dark')
    $('.site-header').removeClass('site-header--inverted')
  } else {
    if (window.location.href === '/') {
      $('.site-header').addClass('site-header--inverted')
    }
  }

  $els.cartContentContainer
    .removeClass('visible opacity-100')
    .addClass('invisible opacity-0')

  setTimeout(() => {
    if ($els.prevFocusedElement) {
      $els.prevFocusedElement.focus()
    } else {
      $els.toggle[0].focus()
    }
  }, 300)

  main.style.overflow = 'auto'
  main.style.height = 'auto'

  document.removeEventListener('keydown', handleFocusTrap)
}
export const openCart = () => {
  const main = document.querySelector('main')
  $els.prevFocusedElement = document.activeElement

  $('.site-header__top-tier').css(`width`, `${document.body.clientWidth}px`)
  $('.site-header__bottom-tier').css(`width`, `${document.body.clientWidth}px`)
  const scrollBarCompensation = window.innerWidth - document.body.offsetWidth
  $els.body.addClass('overflow-hidden cart--open')
  document.body.style.marginRight = `${scrollBarCompensation}px`

  $('.site-header').addClass('toggle--open cart--open')
  $('.site-header').removeClass('site-header--inverted site-header--dark')

  $els.cartContentContainer
    .removeClass('invisible opacity-0')
    .addClass(`visible opacity-100`)
  const event = new CustomEvent('cartOpened')
  document.dispatchEvent(event)
  $els.cartContentContainer[0].focus()
  main.style.overflow = 'hidden'
  main.style.height = 'calc(100dvh - 30px)'
  document.addEventListener('keydown', handleFocusTrap)
}

const handleFocusTrap = (e) => {
  const focusable =
    'button, [href], a, input, select, textarea, [tabindex]:not([tabindex="-1"]) '
  const elementsToFocus =
    $els.cartContentContainer[0].querySelectorAll(focusable)

  const visibleElements = Array.from(elementsToFocus).filter((element) => {
    const styles = window.getComputedStyle(element)
    return styles.display !== 'none' && styles.visibility !== 'hidden'
  })

  const firstElement = visibleElements[0]
  const lastElement = visibleElements[visibleElements.length - 1] // get last element to be focused inside modal

  if (e.key === 'Tab' || e.keyCode === 9) {
    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus()
        e.preventDefault()
      }
    } else if (document.activeElement === lastElement) {
      // Tab from the last element, set focus to the first element
      firstElement.focus()
      e.preventDefault()
    }
  }
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    window.addEventListener('resize', () => {
      $('.site-header__top-tier').css(`width`, `${document.body.clientWidth}px`)
      $('.site-header__bottom-tier').css(
        `width`,
        `${document.body.clientWidth}px`
      )
    })
  },
  false
)

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const updateSubtotalUI = (total) => {
  $els.subtotal.text(priceToCurrency(total))
}

const updateItemsUI = (items) => {
  $els.items.html(
    items
      .map((item, i) => renderCartItem(item, i === items.length - 1))
      .join('\n')
  )
}

const updateDisplayUI = (count) => {
  $els.toggle.text(`Cart (${count})`)
  if (count === 0) {
    $els.footer.hide()
    $els.empty.show()
    $els.fill.css('fill', 'none')
    $els.count.hide()
  } else {
    $els.footer.show()
    $els.empty.hide()
    $els.fill.css('fill', 'black')
    $els.count.show().text(count)
  }
}

const disableCheckout = () => {
  $els.checkout.attr('href', '')
}

const enableCheckout = () => {
  $els.checkout.attr('href', '/checkout')
}

const calculateCartCount = (items) => {
  if (!items) return
  return items.reduce((acc, { quantity }) => acc + quantity, 0)
}

const urlParams = new URLSearchParams(window.location.search)
const view = urlParams.get('view')

export const updateCart = async () => {
  disableCheckout()
  const resp = await Api.fetchCart()
  const cart = resp.data
  const count = calculateCartCount(cart.items)
  updateDisplayUI(count)
  updateItemsUI(cart.items)
  updateSubtotalUI(cart.total_price)
  enableCheckout()

  // if (!count && view !== 'cart') {
  //   closeCart()
  // }
}

$(document).on('keyup', (e) => {
  if (e.key === 'Escape') {
    closeCart()
  }
})
